import { Component, EventEmitter, Input, Output } from '@angular/core';

/**
 * The docked filling-helper bar.
 *
 * Presentational only: it knows nothing about fields, the PDF or the traversal. The signing
 * component owns all of that and feeds this a count and a started flag.
 */
@Component({
  selector: 'sd-filling-helper',
  templateUrl: 'filling-helper.component.html',
  styleUrls: ['filling-helper.component.css'],
  // Declared in SigningModule, like every other component on this page.
  standalone: false
})
export class FillingHelperComponent {

  /** False until Start is pressed — nothing scrolls or highlights before that. */
  @Input() started = false;

  /** Outstanding MANDATORY stops. Zero exactly when the Approve gate passes. */
  @Input() remaining = 0;

  @Output() start = new EventEmitter<void>();
  @Output() next = new EventEmitter<void>();
  @Output() previous = new EventEmitter<void>();
}
